import styled from "styled-components";

export const OrderSection = styled.div`
  margin-bottom: 3rem;
`;
